export default __webpack_public_path__ + "static/media/calc.ea43f573.png";